import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { MENUS } from '../../../utilities/constants/menus.constants';
import { Permissions } from 'src/app/shared/models/permissions.model';
import { Router } from '@angular/router';

@Component({
  selector: 'desktop-menu',
  templateUrl: './desktop-menu.component.html'
})
export class DesktopMenuComponent implements OnInit {

  @Input()
  private permissions: Permissions;

  public menu = MENUS;
  public canViewLoans = true;
  public canViewReports = true;
  public canViewMyProfile = true;
  public canViewAdmin = true;
  public canCRUDMasterAdmin: boolean;

  constructor(private router: Router) { }

  ngOnInit() {
    if(this.permissions) this.setPermissions();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.permissions = changes.permissions.currentValue;
    if(this.permissions) this.setPermissions();
  }

  setPermissions() {
    this.canViewLoans = this.permissions.canViewLoans;
    this.canViewReports = this.permissions.canViewReports;
    this.canViewMyProfile = this.permissions.canViewProfile;
    this.canViewAdmin = this.permissions.canViewAdmin;
    this.canCRUDMasterAdmin = this.permissions.canCRUDMasterAdmin;
  }

  routeTo(route: string) {
    this.router.navigate([route]);
  }
}
